import React, { useState, useEffect, useMemo } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { useFormik } from 'formik';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { ClipLoader } from 'react-spinners';
import { array, mixed, number, object, string } from 'yup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { toast } from 'react-toastify';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import moment from 'moment';
import { authAxiosInstance } from '../../utils/axiosConfig';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import { generateOptions } from '../../utils/Utils';
import { NEW_CREDIT, OLD_CREDIT } from '../../utils/dropdownOptions';
const Report = () => {
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            newCredit: '',
            oldCredit: '',
            from: '',
            to: '',
            brockrage: '',
        },
        validationSchema: object({
            newCredit: string().required(),
            oldCredit: string().required(),
            from: mixed().required(),
            to: mixed().required(),
            brockrage: string().required(),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                console.log('check');
                setLoading(true);
                values.from = moment(values.from).format('YYYY-MM-DD');
                values.to = moment(values.to).format('YYYY-MM-DD');
                console.log(values, 'check');
                let resp = await authAxiosInstance.post(
                    'purchase-orders/report',
                    values
                );
                console.log(resp.data);
                const automationStatus = resp?.data?.automationStatus;
                if (automationStatus === 'inactive') {
                    toast.error('Automation Deactivated', {
                        position: 'top-center',
                        autoClose: false,
                    });
                    throw new Error('Automation Deactivated');
                }
                const customerLength = parseFloat(resp?.data?.customerLength);
                const startDate = resp?.data?.from
                    ? moment(resp.data.from, 'YYYY-MM-DD').format('DD-MM-YYYY')
                    : null;
                const endDate = resp?.data?.to
                    ? moment(resp.data.to, 'YYYY-MM-DD').format('DD-MM-YYYY')
                    : null;

                if (customerLength) {
                    const totalHours = parseFloat(
                        (1000 * 60 * customerLength) / (60 * 60 * 1000)
                    ).toFixed(2);
                    toast.success(
                        `started generating invoices for ${customerLength} customers, expected time ${totalHours} Hours PO`,
                        { position: 'top-center', autoClose: false }
                    );
                    toast.success(
                        `PO Start Date :  ${startDate} endDate ${endDate} `,
                        { position: 'top-center', autoClose: false }
                    );
                } else {
                    toast.warn('customer length not a number');
                    toast.success('Invoice Generation started');
                }
                resetForm();
            } catch (error) {
                console.log(error);
                toast.error('Something Went Wrong while Saving Data');
                resetForm();
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <PageWithCard heading="Generate Report">
            <div>
                {loading ? (
                    <ClipLoader />
                ) : (
                    <form
                        className="flex flex-col gap-4"
                        onSubmit={formik.handleSubmit}
                    >
                        <FormikInputGroup
                            name={`brockrage`}
                            label={'Brockrage Mode'}
                            formik={formik}
                            // type="number"
                        />
                        <FormikSelectGroup
                            formik={formik}
                            label="Old Credit Score"
                            name={`oldCredit`}
                            options={generateOptions({
                                array: OLD_CREDIT,
                                labelField: 'label',
                                valueField: 'value',
                            })}
                            required
                        />
                        <FormikSelectGroup
                            formik={formik}
                            label="New Credit Score"
                            name={`newCredit`}
                            options={generateOptions({
                                array: NEW_CREDIT,
                                labelField: 'label',
                                valueField: 'value',
                            })}
                            required
                        />

                        <FormikInputDateGroup
                            name="from"
                            label="From"
                            formik={formik}
                        />
                        <FormikInputDateGroup
                            label="To"
                            name="to"
                            formik={formik}
                        />

                        <div className="flex gap-3">
                            <PrimaryButton type="submit">Submit</PrimaryButton>
                        </div>
                    </form>
                )}
            </div>
        </PageWithCard>
    );
};

export default Report;
